import { render } from "./Logout.vue?vue&type=template&id=b3328694&ts=true"
import script from "./Logout.vue?vue&type=script&lang=ts"
export * from "./Logout.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__